<div class="h-full bg-gray-50 overflow-y-auto">
    <div class="px-6 py-7">

        <!-- Header -->
        <div class="flex items-start justify-between gap-4 mb-6">
            <div>
                <h1 class="text-2xl font-bold text-gray-900">Tasks</h1>
                <p class="text-sm text-gray-500 mt-1">
                    {{ activeCount }} active task{{ activeCount !== 1 ? 's' : '' }}
                    @if(dueThisWeekCount > 0) { <span class="text-gray-300">·</span> {{ dueThisWeekCount }} due this week }
                </p>
            </div>
            <button (click)="openNew()"
                class="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors shadow-sm cursor-pointer shrink-0">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                </svg>
                New Task
            </button>
        </div>

        <!-- Tabs -->
        <div class="flex items-center gap-6 border-b border-gray-200 mb-5">
            <button type="button" (click)="setTodoTab('assigned')"
                class="flex items-center gap-2 pb-3 -mb-px text-sm font-semibold border-b-2 transition-colors cursor-pointer"
                [class]="todoTab === 'assigned' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-800'">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0M12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                Assigned to me
            </button>
            <button type="button" (click)="setTodoTab('created')"
                class="flex items-center gap-2 pb-3 -mb-px text-sm font-semibold border-b-2 transition-colors cursor-pointer"
                [class]="todoTab === 'created' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-800'">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                Created by me
            </button>
        </div>

        <!-- Search -->
        <div class="relative mb-3">
            <svg class="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input type="text" [(ngModel)]="filterSearch" (ngModelChange)="onSearchChange()" placeholder="Search a task…"
                class="w-full pl-10 pr-4 py-2.5 text-sm bg-white border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all shadow-sm placeholder-gray-400">
        </div>

        <!-- Filter chips -->
        <div class="flex flex-wrap items-center gap-2 mb-5">
            <!-- Status -->
            <div class="relative">
                <select [(ngModel)]="filterStatus" (change)="onFilterChange()"
                    class="appearance-none pl-3.5 pr-8 py-2 text-sm font-medium border rounded-lg cursor-pointer transition-all focus:outline-none focus:ring-2 focus:ring-blue-400"
                    [class]="filterStatus ? 'bg-blue-50 border-blue-300 text-blue-700' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'">
                    <option value="">All statuses</option>
                    <option value="TODO">To Do</option>
                    <option value="IN_PROGRESS">In Progress</option>
                    <option value="DONE">Done</option>
                </select>
                <svg class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" /></svg>
            </div>

            <!-- Priority -->
            <div class="relative">
                <select [(ngModel)]="filterPriority" (change)="onFilterChange()"
                    class="appearance-none pl-3.5 pr-8 py-2 text-sm font-medium border rounded-lg cursor-pointer transition-all focus:outline-none focus:ring-2 focus:ring-blue-400"
                    [class]="filterPriority ? 'bg-amber-50 border-amber-300 text-amber-700' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'">
                    <option value="">All priorities</option>
                    <option value="LOW">Low</option>
                    <option value="MEDIUM">Medium</option>
                    <option value="HIGH">High</option>
                </select>
                <svg class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" /></svg>
            </div>

            <!-- Client -->
            <div class="relative">
                <select [(ngModel)]="filterClientId" (change)="onFilterChange()"
                    class="appearance-none pl-3.5 pr-8 py-2 text-sm font-medium border rounded-lg cursor-pointer transition-all focus:outline-none focus:ring-2 focus:ring-blue-400"
                    [class]="filterClientId ? 'bg-purple-50 border-purple-300 text-purple-700' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'">
                    <option value="">All clients</option>
                    @for(c of clients; track c.id) { <option [value]="c.id">{{ c.name }}</option> }
                </select>
                <svg class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" /></svg>
            </div>

            <!-- Project -->
            <div class="relative">
                <select [(ngModel)]="filterProjectId" (change)="applyFilters()"
                    class="appearance-none pl-3.5 pr-8 py-2 text-sm font-medium border rounded-lg cursor-pointer transition-all focus:outline-none focus:ring-2 focus:ring-blue-400"
                    [class]="filterProjectId ? 'bg-indigo-50 border-indigo-300 text-indigo-700' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'">
                    <option value="">All projects</option>
                    @for(p of projects; track p.id) { <option [value]="p.id">{{ p.projectName }}</option> }
                </select>
                <svg class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" /></svg>
            </div>

            <!-- Tenant (only when several) -->
            @if(tenants.length > 1) {
            <div class="relative">
                <select [(ngModel)]="filterTenantId" (change)="onFilterChange()"
                    class="appearance-none pl-3.5 pr-8 py-2 text-sm font-medium border rounded-lg cursor-pointer transition-all focus:outline-none focus:ring-2 focus:ring-blue-400"
                    [class]="filterTenantId ? 'bg-violet-50 border-violet-300 text-violet-700' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'">
                    <option value="">All tenants</option>
                    @for(t of tenants; track t.id) { <option [value]="t.id">{{ t.name }}</option> }
                </select>
                <svg class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" /></svg>
            </div>
            }

            <!-- Backlog toggle -->
            <button type="button" (click)="filterBacklog = !filterBacklog; onFilterChange()"
                class="flex items-center gap-2 pl-3 pr-3.5 py-2 text-sm font-medium border rounded-lg transition-all cursor-pointer"
                [class]="filterBacklog ? 'bg-amber-50 border-amber-300 text-amber-700 shadow-sm' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
                Backlog
            </button>

            <div class="flex-1"></div>

            @if(hasActiveFilters) {
            <button (click)="clearFilters()"
                class="flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-gray-500 hover:text-red-600 hover:bg-red-50 border border-transparent rounded-lg transition-all cursor-pointer">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12" /></svg>
                Clear filters
            </button>
            }
        </div>

        <!-- List -->
        @if(isLoading) {
        <div class="flex flex-col items-center justify-center py-24 gap-3 text-gray-400">
            <svg class="w-8 h-8 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
            </svg>
            <p class="text-sm font-medium">Loading tasks…</p>
        </div>
        }

        @if(!isLoading && filtered.length === 0) {
        <div class="flex flex-col items-center justify-center py-24 text-center">
            <div class="w-16 h-16 mb-4 rounded-2xl bg-gray-100 flex items-center justify-center">
                <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
            </div>
            <p class="text-gray-500 font-medium">No tasks yet</p>
            <p class="text-gray-400 text-sm mt-1">{{ hasActiveFilters ? 'Try clearing the filters' : 'Create your first task' }}</p>
        </div>
        }

        @if(!isLoading && filtered.length > 0) {
        <div class="space-y-2.5">
            @for(todo of filtered; track todo.id) {
            @let due = getDueDisplay(todo.dueDate, todo.status);
            @let isDone = todo.status === 'DONE';
            <div class="bg-white rounded-xl border border-gray-200 px-4 py-3.5 flex items-start gap-3.5 hover:shadow-sm hover:border-gray-300 transition-all group">

                <!-- Circular checkbox — toggle DONE -->
                <button type="button" (click)="quickComplete(todo)"
                    [title]="isDone ? 'Mark as To Do' : 'Mark as Done'"
                    class="shrink-0 mt-0.5 w-5 h-5 rounded-full cursor-pointer focus:outline-none group/dot block">
                    @if(isDone) {
                    <span class="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center hover:bg-red-400 transition-colors">
                        <svg class="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>
                    </span>
                    } @else {
                    <span class="w-5 h-5 rounded-full border-2 flex items-center justify-center hover:border-green-400 hover:bg-green-50 transition-colors"
                        [class]="todo.status === 'IN_PROGRESS' ? 'border-blue-400 bg-blue-50' : 'border-gray-300'">
                        <svg class="w-3 h-3 text-green-400 opacity-0 group-hover/dot:opacity-100 transition-opacity" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>
                    </span>
                    }
                </button>

                <!-- Content -->
                <div class="flex-1 min-w-0 cursor-pointer" (click)="openDetail(todo)">
                    <div class="flex items-center gap-2 flex-wrap">
                        <span class="font-semibold text-gray-900 text-sm group-hover:text-blue-700 transition-colors" [class.line-through]="isDone" [class.text-gray-400]="isDone">{{ todo.name }}</span>
                        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold" [class]="statusColor(todo.status)">{{ statusLabel(todo.status) }}</span>
                        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold" [class]="priorityColor(todo.priority)">{{ priorityLabel(todo.priority) }}</span>
                    </div>

                    @if(todo.description) {
                    <p class="text-xs text-gray-500 mt-1 leading-[1.5] line-clamp-1">{{ todo.description }}</p>
                    }

                    <!-- Scope breadcrumb -->
                    <div class="flex items-center gap-1.5 mt-2 text-xs text-gray-500 flex-wrap">
                        <svg class="w-3.5 h-3.5 text-gray-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0M12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        @if(!todo.tenantId && !todo.clientId && !todo.projectId) {
                        <span class="inline-flex items-center gap-1 text-amber-600 font-medium">Backlog</span>
                        } @else {
                            @if(clientName(todo.clientId); as cn) { <span>{{ cn }}</span> }
                            @else if(tenantName(todo.tenantId); as tn) { <span>{{ tn }}</span> }
                            @if((clientName(todo.clientId) || tenantName(todo.tenantId)) && projectName(todo.projectId)) {
                            <svg class="w-3 h-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
                            }
                            @if(projectName(todo.projectId); as pn) { <span class="text-indigo-600 font-medium">{{ pn }}</span> }
                        }
                    </div>
                </div>

                <!-- Right: due + creator, actions on hover -->
                <div class="flex flex-col items-end gap-0.5 shrink-0 text-right">
                    @if(due) {
                    <span class="text-xs whitespace-nowrap" [class.text-red-600]="due.urgent" [class.font-semibold]="due.urgent" [class.text-gray-500]="!due.urgent">{{ due.text }}</span>
                    }
                    @if(getUserShortName(todo.creatorId); as cName) {
                    <span class="text-xs text-gray-400">{{ cName }}</span>
                    }
                    <div class="flex items-center gap-0.5 mt-1 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button (click)="openEdit(todo)" class="p-1.5 rounded-lg text-gray-400 hover:text-blue-600 hover:bg-blue-50 transition-colors cursor-pointer">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
                        </button>
                        <button (click)="requestDelete(todo)" class="p-1.5 rounded-lg text-gray-400 hover:text-red-600 hover:bg-red-50 transition-colors cursor-pointer">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>

        <!-- Load more -->
        @if(hasMore) {
        <div class="flex justify-center pt-4 pb-2">
            <button type="button" (click)="loadMore()" [disabled]="isLoadingMore"
                class="flex items-center gap-2 px-5 py-2.5 bg-white border border-gray-200 text-sm font-semibold text-gray-600 rounded-xl hover:bg-gray-50 hover:border-gray-300 transition-all shadow-sm disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer">
                @if(isLoadingMore) {
                <svg class="w-4 h-4 animate-spin text-gray-400" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path></svg>
                Loading…
                } @else {
                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /></svg>
                Load more
                }
            </button>
        </div>
        }
        }
    </div>
</div>

<!-- ─── Create / Edit Modal — full page ──────────────────────────────────── -->
@if(showModal) {
<div class="fixed inset-0 z-50 flex items-start justify-center bg-black/50 backdrop-blur-sm p-0" (click)="closeModal()">

    <!-- Full-page panel -->
    <div class="w-full h-full bg-white flex flex-col overflow-hidden" (click)="$event.stopPropagation()">

        <!-- Header -->
        <div class="flex items-center justify-between px-7 py-5 border-b border-gray-200 bg-gray-50 flex-shrink-0">
            <div class="flex items-center gap-4">
                <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shrink-0 shadow-sm">
                    <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                    </svg>
                </div>
                <div>
                    <p class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-0.5">
                        {{ isEditing ? 'Edit task' : 'New task' }}
                    </p>
                    <h2 class="text-xl font-bold text-gray-800">
                        {{ (isEditing && todoForm.name) ? todoForm.name : (isEditing ? 'Edit task' : 'Create a task') }}
                    </h2>
                </div>
                <!-- Type switcher -->
                <div class="flex items-center bg-gray-200 rounded-lg p-1 gap-1">
                    <button type="button" (click)="switchToInternal()"
                        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-semibold transition-all cursor-pointer"
                        [class]="todoType === 'internal' ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-500 hover:text-gray-700'">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0M12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        Internal
                    </button>
                    <button type="button" (click)="switchToExternal()"
                        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-semibold transition-all cursor-pointer"
                        [class]="todoType === 'external' ? 'bg-blue-600 text-white shadow-sm' : 'text-gray-500 hover:text-gray-700'">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                        External
                    </button>
                </div>
            </div>
            <button (click)="closeModal()"
                class="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer text-2xl leading-none p-1">
                &times;
            </button>
        </div>

        <!-- Scrollable body -->
        <div class="flex-1 overflow-y-auto bg-gray-50/40">
            <div class="max-w-3xl mx-auto px-8 py-8 space-y-6">

                <!-- Section: Details -->
                <div class="rounded-xl border border-gray-200 bg-white p-5 space-y-4">
                    <div class="flex items-center gap-1.5 text-xs text-gray-400 font-bold uppercase tracking-wider">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
                        Details
                    </div>

                    <!-- Title -->
                    <div class="flex flex-col">
                        <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">
                            Title <span class="text-red-500">*</span>
                        </label>
                        <input type="text" [(ngModel)]="todoForm.name" placeholder="What needs to be done?" autofocus
                            class="border border-gray-300 rounded-lg px-3.5 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition text-sm">
                    </div>

                    <!-- Description -->
                    <div class="flex flex-col">
                        <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Description</label>
                        <textarea [(ngModel)]="todoForm.description" rows="3" placeholder="Add more context or details…"
                            class="border border-gray-300 rounded-lg px-3.5 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 resize-y transition text-sm"></textarea>
                    </div>
                </div>

                <!-- Section: Classification -->
                <div class="rounded-xl border border-gray-200 bg-white p-5 space-y-4">
                    <div class="flex items-center gap-1.5 text-xs text-gray-400 font-bold uppercase tracking-wider">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5a1.99 1.99 0 011.414.586l7 7a2 2 0 010 2.828l-5 5a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z" /></svg>
                        Classification
                    </div>

                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
                        <!-- Status -->
                        <div class="flex flex-col">
                            <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Status</label>
                            <div class="grid grid-cols-3 gap-1.5">
                                <button type="button" (click)="todoForm.status = 'TODO'"
                                    class="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition-all cursor-pointer"
                                    [ngClass]="todoForm.status === 'TODO' ? 'bg-slate-50 border-slate-400 text-slate-700' : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'">
                                    <span class="w-2 h-2 rounded-full bg-slate-400"></span> To Do
                                </button>
                                <button type="button" (click)="todoForm.status = 'IN_PROGRESS'"
                                    class="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition-all cursor-pointer"
                                    [ngClass]="todoForm.status === 'IN_PROGRESS' ? 'bg-blue-50 border-blue-400 text-blue-700' : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'">
                                    <span class="w-2 h-2 rounded-full bg-blue-500"></span> In Progress
                                </button>
                                <button type="button" (click)="todoForm.status = 'DONE'"
                                    class="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition-all cursor-pointer"
                                    [ngClass]="todoForm.status === 'DONE' ? 'bg-emerald-50 border-emerald-400 text-emerald-700' : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'">
                                    <span class="w-2 h-2 rounded-full bg-emerald-500"></span> Done
                                </button>
                            </div>
                        </div>

                        <!-- Priority -->
                        <div class="flex flex-col">
                            <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Priority</label>
                            <div class="grid grid-cols-3 gap-1.5">
                                <button type="button" (click)="todoForm.priority = 'LOW'"
                                    class="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition-all cursor-pointer"
                                    [ngClass]="todoForm.priority === 'LOW' ? 'bg-gray-50 border-gray-400 text-gray-700' : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'">
                                    <span class="w-2 h-2 rounded-full bg-gray-400"></span> Low
                                </button>
                                <button type="button" (click)="todoForm.priority = 'MEDIUM'"
                                    class="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition-all cursor-pointer"
                                    [ngClass]="todoForm.priority === 'MEDIUM' ? 'bg-amber-50 border-amber-400 text-amber-700' : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'">
                                    <span class="w-2 h-2 rounded-full bg-amber-500"></span> Medium
                                </button>
                                <button type="button" (click)="todoForm.priority = 'HIGH'"
                                    class="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition-all cursor-pointer"
                                    [ngClass]="todoForm.priority === 'HIGH' ? 'bg-red-50 border-red-400 text-red-700' : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'">
                                    <span class="w-2 h-2 rounded-full bg-red-500"></span> High
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Section: Schedule & Scope -->
                <div class="rounded-xl border border-gray-200 bg-white p-5 space-y-4">
                    <div class="flex items-center gap-1.5 text-xs text-gray-400 font-bold uppercase tracking-wider">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                        Schedule &amp; Scope
                    </div>

                    <!-- Due date -->
                    <div class="flex flex-col gap-3">
                        <label class="flex items-center gap-2.5 cursor-pointer">
                            <input type="checkbox" [(ngModel)]="hasDueDate" (change)="onDueDateToggle()"
                                class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500">
                            <span class="text-sm font-semibold text-gray-700">Set a due date</span>
                        </label>
                        @if(hasDueDate) {
                        <input type="date" [(ngModel)]="todoForm.dueDate"
                            class="border border-gray-300 rounded-lg px-3.5 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm transition">
                        }
                    </div>

                    <!-- Tenant (Internal) — auto-selected if single, dropdown if multiple -->
                @if(todoType === 'internal') {
                <div class="flex flex-col">
                    <label class="text-sm text-gray-700 font-semibold mb-1.5">Tenant</label>
                    @if(tenants.length === 0) {
                    <p class="text-sm text-gray-400 italic">No tenant available</p>
                    }
                    @if(tenants.length === 1) {
                    <!-- Single tenant: show as read-only chip -->
                    <div
                        class="flex items-center gap-2 px-3 py-2.5 bg-gray-100 border border-gray-200 rounded-lg w-fit">
                        <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5" />
                        </svg>
                        <span class="text-sm font-semibold text-gray-700">{{ tenants[0].name }}</span>
                        <span class="text-xs text-gray-400">(auto-selected)</span>
                    </div>
                    }
                    @if(tenants.length > 1) {
                    <!-- Multiple tenants: dropdown -->
                    <div class="relative">
                        <select [(ngModel)]="todoForm.tenantId"
                            class="w-full border border-gray-300 rounded-lg p-3 pr-10 focus:ring-2 focus:ring-blue-500 outline-none bg-white cursor-pointer transition-shadow appearance-none text-sm">
                            <option [ngValue]="undefined">— Select your tenant —</option>
                            @for(t of tenants; track t.id) {
                            <option [value]="t.id">{{ t.name }}</option>
                            }
                        </select>
                        <div
                            class="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none text-gray-500">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                    </div>
                    }
                </div>
                }

                <!-- Project search (External) — fast single-input picker -->
                @if(todoType === 'external') {
                <div class="flex flex-col gap-2">
                    <label class="text-sm text-gray-700 font-semibold">
                        Project <span class="text-red-500">*</span>
                        <span class="text-xs font-normal text-gray-400 ml-1">— type to search</span>
                    </label>

                    <!-- Selected project chip -->
                    @if(selectedProject) {
                    <div
                        class="flex items-center justify-between px-3 py-2.5 bg-blue-50 border border-blue-300 rounded-lg">
                        <div>
                            <p class="text-sm font-semibold text-blue-800">{{ selectedProject.projectName }}</p>
                            <p class="text-xs text-blue-500">{{ selectedProject.clientName }}</p>
                        </div>
                        <button type="button" (click)="clearProjectSelection()"
                            class="text-blue-400 hover:text-red-500 transition-colors cursor-pointer p-1">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    }

                    <!-- Search input (hidden once project selected) -->
                    @if(!selectedProject) {
                    <div class="relative">
                        <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
                            fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input type="text" [(ngModel)]="projectSearch" (ngModelChange)="onProjectSearch()"
                            placeholder="Search by project or client name…" autofocus
                            class="w-full pl-9 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm transition-shadow placeholder-gray-400">
                    </div>

                    <!-- Results list -->
                    @if(isSearchingProjects) {
                    <div class="flex items-center gap-2 px-1 py-2 text-sm text-gray-400">
                        <svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                        </svg>
                        Searching…
                    </div>
                    }
                    @if(!isSearchingProjects && projectSearch && filteredProjects.length === 0) {
                    <p class="text-sm text-amber-600 italic">No projects match "{{ projectSearch }}"</p>
                    }
                    @if(!isSearchingProjects && filteredProjects.length > 0) {
                    <div class="border border-gray-200 rounded-lg overflow-hidden max-h-56 overflow-y-auto">
                        @for(p of filteredProjects; track p.id) {
                        <button type="button" (click)="selectProject(p)"
                            class="w-full flex items-center justify-between px-4 py-3 hover:bg-blue-50 border-b border-gray-100 last:border-0 text-left transition-colors cursor-pointer group">
                            <div>
                                <p class="text-sm font-semibold text-gray-800 group-hover:text-blue-700">{{
                                    p.projectName }}</p>
                                <p class="text-xs text-gray-400">{{ p.clientName }}</p>
                            </div>
                            <svg class="w-4 h-4 text-gray-300 group-hover:text-blue-500 transition-colors" fill="none"
                                stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 5l7 7-7 7" />
                            </svg>
                        </button>
                        }
                    </div>
                    }
                    }

                    @if(todoType === 'external' && !todoForm.projectId) {
                    <p class="text-xs text-red-500">A project is required for external todos</p>
                    }
                </div>
                }
                </div><!-- /Schedule & Scope card -->

                <!-- Section: Team -->
                <div class="rounded-xl border border-gray-200 bg-white p-5 space-y-4">
                    <div class="flex items-center gap-1.5 text-xs text-gray-400 font-bold uppercase tracking-wider">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-1.13a4 4 0 10-4-4 4 4 0 004 4z" /></svg>
                        Team
                    </div>

                    <!-- Assigned users -->
                    @if(assignableUsers.length > 0) {
                    <div class="flex flex-col">
                        <label class="text-xs text-gray-500 font-semibold mb-2 uppercase tracking-wide">
                            Assign to @if(selectedUsers.length) { <span class="text-blue-600 normal-case">({{ selectedUsers.length }})</span> }
                        </label>
                        <div class="flex flex-wrap gap-2">
                            @for(u of assignableUsers; track u.id) {
                            <button type="button" (click)="toggleUser(u.id)"
                                class="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-all border cursor-pointer"
                                [class]="isUserSelected(u.id)
                              ? 'bg-blue-600 text-white border-blue-600 shadow-sm'
                              : 'bg-white text-gray-600 border-gray-300 hover:border-blue-400 hover:bg-blue-50'">
                                <div class="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold"
                                    [class]="isUserSelected(u.id) ? 'bg-blue-500 text-white' : 'bg-blue-100 text-blue-700'">
                                    {{ (u.firstName || u.name || '?')[0].toUpperCase() }}
                                </div>
                                {{ u.firstName || u.name }}
                            </button>
                            }
                        </div>
                    </div>
                    } @else {
                    <p class="text-sm text-gray-400 italic">No users available</p>
                    }
                </div>

            </div><!-- /max-w-3xl -->
        </div><!-- /scrollable -->

        <!-- Footer -->
        <div class="flex items-center justify-between px-8 py-4 border-t border-gray-200 bg-gray-50 flex-shrink-0">
            <button type="button" (click)="closeModal()"
                class="px-5 py-2.5 text-gray-700 font-medium hover:bg-gray-100 rounded-lg transition-colors cursor-pointer text-sm">
                Cancel
            </button>
            <button type="button" (click)="saveTodo()" [disabled]="!todoForm.name?.trim()"
                class="bg-blue-600 text-white font-bold py-2.5 px-6 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm cursor-pointer flex items-center gap-2 text-sm">
                {{ isEditing ? 'Save changes' : 'Create todo' }}
            </button>
        </div>

    </div><!-- /full-page panel -->
</div>
}

<!-- ─── Read-only details view ("in-between" view) ──────────────────────────── -->
@if(showDetail && detailTodo) {
@let isDone = detailTodo.status === 'DONE';
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4" (click)="closeDetail()">
    <div class="bg-white rounded-2xl shadow-2xl overflow-hidden w-full max-w-2xl flex flex-col max-h-[90vh]" (click)="$event.stopPropagation()">

        <!-- Header -->
        <div class="px-6 py-4 border-b border-gray-100 flex justify-between items-center shrink-0">
            <div class="flex items-center gap-3 min-w-0">
                <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shrink-0 shadow-sm">
                    <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                    </svg>
                </div>
                <div class="min-w-0">
                    <h2 class="font-bold text-lg text-gray-900 leading-tight truncate">Task details</h2>
                    <p class="text-xs text-gray-400">Read-only overview</p>
                </div>
            </div>
            <div class="flex items-center gap-2 shrink-0">
                <button type="button" (click)="editFromDetail()"
                    class="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-semibold text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors cursor-pointer">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                    </svg>
                    Edit
                </button>
                <button (click)="closeDetail()" class="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>

        <!-- Body -->
        <div class="px-6 py-5 overflow-y-auto custom-scrollbar flex-1 space-y-6 bg-gray-50/40">

            <!-- Hero -->
            <div class="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
                <div class="h-1.5 w-full" [ngClass]="detailStatusAccent"></div>
                <div class="p-5 space-y-3">
                    <div class="flex items-center gap-2 flex-wrap">
                        <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold" [class]="statusColor(detailTodo.status)">{{ statusLabel(detailTodo.status) }}</span>
                        <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold" [class]="priorityColor(detailTodo.priority)">{{ priorityLabel(detailTodo.priority) }}</span>
                        @if(detailIsOverdue) {
                        <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border border-red-200 bg-red-50 text-red-700">
                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" /></svg>
                            Overdue
                        </span>
                        }
                    </div>
                    <h3 class="text-2xl font-bold text-gray-900 leading-snug break-words" [class.line-through]="isDone" [class.text-gray-400]="isDone">{{ detailTodo.name }}</h3>
                </div>
            </div>

            <!-- Description -->
            <div class="rounded-xl border border-gray-200 bg-white p-4">
                <div class="flex items-center gap-1.5 text-xs text-gray-500 font-semibold mb-2 uppercase tracking-wide">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" /></svg>
                    Description
                </div>
                @if(detailTodo.description) {
                <p class="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">{{ detailTodo.description }}</p>
                } @else {
                <p class="text-sm text-gray-400 italic">No description added</p>
                }
            </div>

            <!-- Schedule + Scope -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <!-- Due date -->
                <div class="rounded-xl border bg-white p-4" [ngClass]="detailIsOverdue ? 'border-red-200 bg-red-50/60' : 'border-gray-200'">
                    <div class="flex items-center gap-1.5 text-xs font-semibold mb-1" [ngClass]="detailIsOverdue ? 'text-red-600' : 'text-gray-500'">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                        Due date
                    </div>
                    @if(detailTodo.dueDate) {
                    <div class="text-sm font-medium" [ngClass]="detailIsOverdue ? 'text-red-700' : 'text-gray-800'">{{ formatDateDisplay(detailTodo.dueDate) }}</div>
                    <div class="text-xs mt-0.5" [ngClass]="detailIsOverdue ? 'text-red-500' : 'text-gray-400'">{{ detailDueRelative }}</div>
                    } @else {
                    <div class="text-sm text-gray-400 italic">No due date</div>
                    }
                </div>

                <!-- Scope -->
                <div class="rounded-xl border border-gray-200 bg-white p-4">
                    <div class="flex items-center gap-1.5 text-xs text-gray-500 font-semibold mb-1 uppercase tracking-wide">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
                        Scope
                    </div>
                    @if(!detailTodo.tenantId && !detailTodo.clientId && !detailTodo.projectId) {
                    <div class="text-sm font-medium text-amber-600">Backlog</div>
                    } @else {
                    <div class="flex items-center gap-1.5 text-sm text-gray-700 flex-wrap">
                        @if(clientName(detailTodo.clientId); as cn) { <span class="font-medium">{{ cn }}</span> }
                        @else if(tenantName(detailTodo.tenantId); as tn) { <span class="font-medium">{{ tn }}</span> }
                        @if((clientName(detailTodo.clientId) || tenantName(detailTodo.tenantId)) && projectName(detailTodo.projectId)) {
                        <svg class="w-3 h-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
                        }
                        @if(projectName(detailTodo.projectId); as pn) { <span class="text-indigo-600 font-medium">{{ pn }}</span> }
                    </div>
                    }
                </div>
            </div>

            <!-- Assigned to -->
            <div>
                <div class="flex items-center gap-1.5 text-xs text-gray-500 font-semibold mb-2 uppercase tracking-wide">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-1.13a4 4 0 10-4-4 4 4 0 004 4z" /></svg>
                    Assigned to @if(detailAssignedUsers.length) { <span class="text-blue-600 normal-case">({{ detailAssignedUsers.length }})</span> }
                </div>
                @if(detailAssignedUsers.length > 0) {
                <div class="rounded-xl border border-gray-200 bg-white divide-y divide-gray-100 overflow-hidden">
                    @for(u of detailAssignedUsers; track u.id) {
                    <div class="flex items-center gap-3 px-3 py-2.5">
                        <span class="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-[10px] font-bold shrink-0">{{ getInitials(u) }}</span>
                        <div class="min-w-0">
                            <div class="text-sm font-medium text-gray-800 truncate">{{ u.firstName }} {{ u.name }}</div>
                            @if(u.email) { <div class="text-xs text-gray-400 truncate">{{ u.email }}</div> }
                        </div>
                    </div>
                    }
                </div>
                } @else {
                <div class="rounded-xl border border-dashed border-gray-200 bg-white px-3 py-4 text-sm text-gray-400 italic text-center">No one assigned</div>
                }
            </div>

            <!-- Validation -->
            @if(detailTodo.validatedBy) {
            <div class="flex items-center gap-2.5 rounded-xl border border-emerald-200 bg-emerald-50/60 px-3 py-2.5">
                <span class="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
                    <svg class="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                </span>
                <div class="min-w-0">
                    <div class="text-xs text-emerald-700 font-semibold uppercase tracking-wide">Validated</div>
                    <div class="text-sm text-gray-700 truncate">
                        by {{ getValidatedByName(detailTodo.validatedBy) }}@if(detailTodo.validatedAt) { · {{ formatDateDisplay(detailTodo.validatedAt) }} }
                    </div>
                </div>
            </div>
            }
        </div>

        <!-- Footer -->
        <div class="flex justify-between items-center px-6 py-3.5 border-t border-gray-100 shrink-0 bg-gray-50/50">
            <button type="button" (click)="deleteFromDetail()"
                class="inline-flex items-center gap-2 px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg text-sm font-medium transition-colors cursor-pointer">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                Delete
            </button>
            <div class="flex gap-2">
                <button type="button" (click)="closeDetail()"
                    class="px-4 py-2.5 text-gray-700 text-sm font-medium hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
                    Close
                </button>
                <button type="button" (click)="editFromDetail()"
                    class="inline-flex items-center gap-2 bg-blue-600 text-white text-sm font-semibold py-2.5 px-5 rounded-lg hover:bg-blue-700 transition-colors shadow-sm cursor-pointer">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                    </svg>
                    Edit Task
                </button>
            </div>
        </div>
    </div>
</div>
}

<!-- Delete confirm -->
@if(showDeleteConfirm) {
<app-confirm-modal [message]="'Delete todo &quot;' + todoToDelete?.name + '&quot;? This cannot be undone.'"
    (close)="handleDeleteConfirm($event)">
</app-confirm-modal>
}
